module.exports = __webpack_public_path__ + "img/cp8.547b69ce.png";